<template>
  <div class="mx-auto mt-20 md:w-2/6 w-full p-8">
    <h1 class="font-bold text-4xl">Skapa konto</h1>

    <FormErrors :errors="errors" subject="user" />

    <form :action="usersPath" method="post">
      <input type="hidden" name="authenticity_token" :value="csrfToken" />

      <div class="my-5">
        <Label>E-post</Label>
        <Input
          type="email"
          name="user[email_address]"
          required
          autofocus
          autocomplete="username"
          placeholder="E-postadress"
          class="mt-2"
        />
      </div>

      <div class="my-5">
        <Label>Lösenord</Label>
        <Input
          type="password"
          name="user[password]"
          required
          autocomplete="new-password"
          placeholder="Lösenord"
          maxlength="72"
          class="mt-2"
        />
      </div>

      <div class="my-5">
        <Label>Bekräfta lösenord</Label>
        <Input
          type="password"
          name="user[password_confirmation]"
          required
          autocomplete="new-password"
          placeholder="Bekräfta lösenord"
          maxlength="72"
          class="mt-2"
        />
      </div>

      <Button type="submit">Skapa konto</Button>
    </form>
  </div>
</template>

<script setup>
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import FormErrors from "@/components/form/FormErrors.vue";

defineProps({
  csrfToken: { type: String, required: true },
  usersPath: { type: String, required: true },
  errors: { type: Array, default: () => [] },
});
</script>
